export default "__VITE_ASSET__BmNVwe$o__"